export default __webpack_public_path__ + "assets/light-celebrate-6-large.png";